export default __webpack_public_path__ + "static/char-v-59-3eed932833d435087ae585b7278ec4a8.png";